import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { LanguageComplianceFilters } from './widgets/language-compliance-filter/LanguageComplianceFilters'
import { BpTabs } from '../../shared/components/utility/tabs/BpTabs'
import { BpTab } from '../../shared/components/utility/tabs/tab/BpTab'
import { AllChecksTable } from './widgets/all-checks-table/AllChecksTable'
import { LastCheckTable } from './widgets/last-check-table/LastCheckTable'
import { InProgressTable } from './widgets/in-progress-table/InProgressTable'
import {
  GetLanguageComplianceCounterApiArg,
  useGetLanguageComplianceCounterQuery,
  useGetLanguageComplianceFilterProjectQuery,
} from '../../app/api'
import { LanguageComplianceStub } from './widgets/language-compliance-stub/LanguageComplianceStub'
import { useAppSelector } from '../../app/store/hooks/Redux'
import { selectLanguageComplianceFilter } from './model/languageComplianceSlice'
import { ILanguageComplianceFilter } from './model/types/LanguageComplianceFilter.interface'
import { LanguageCompiliancePanel } from './widgets/language-compliance-panel/LanguageCompiliancePanel'
import clsx from 'clsx'

import styles from './LanguageCompliancePage.module.scss'
import { useTranslation } from 'react-i18next'

export const LanguageCompliancePage = () => {
  const { t } = useTranslation()
  const filters = useAppSelector<ILanguageComplianceFilter>(selectLanguageComplianceFilter)
  const { project, country, url, affiliate, dateRange, restrictedWords, hidden } = filters

  const { data: projects, isLoading, isFetching } = useGetLanguageComplianceFilterProjectQuery()
  const enabled = !!projects?.data?.length
  const { data: counter } = useGetLanguageComplianceCounterQuery(
    {
      date: dateRange,
      projectId: Number(project),
      countryId: country,
      urlId: url || undefined,
      affiliate: affiliate,
      wordId: restrictedWords || undefined,
      showHidden: hidden,
    } as unknown as GetLanguageComplianceCounterApiArg,
    { skip: !project || !country },
  )

  return (
    <CommonMainPage
      hint={t('navigation.hint.nonCompliantContent')}
      title={t('navigation.nonCompliantContent')}
    >
      {enabled ? (
        <section className={clsx(styles.wrapper)}>
          <LanguageComplianceFilters />
          <BpTabs className={clsx(styles.tabs)} size={'md'}>
            <BpTab
              counter={counter?.data?.history ? String(counter?.data?.history) : undefined}
              panel={<LanguageCompiliancePanel />}
              title={'All Checks'}
            >
              <AllChecksTable />
            </BpTab>
            <BpTab
              counter={counter?.data?.last_check ? String(counter?.data?.last_check) : undefined}
              panel={<LanguageCompiliancePanel />}
              title={'Infringements'}
            >
              <LastCheckTable />
            </BpTab>
            <BpTab
              counter={counter?.data?.in_progress ? String(counter?.data?.in_progress) : undefined}
              panel={<LanguageCompiliancePanel />}
              title={'In Progress'}
            >
              <InProgressTable />
            </BpTab>
          </BpTabs>
        </section>
      ) : (
        <LanguageComplianceStub isLoading={isLoading || isFetching} />
      )}
    </CommonMainPage>
  )
}
